import rpcHeaders from '#/store/headers';
import { ingestClient } from '#/clients';
import { EntityId } from '../../protobuf/general_pb';

export function emptyState() {
  return {
    items: [],
  };
}

export const getters = {
  cartItems: (state) => state.items,
  cartJobs: (state) => state.items.filter((item) => item.itemType !== 'job'),
  cartEntities: (state) => state.items.filter((item) => item.itemType !== 'entity'),
  cartIds: (state) => state.items.map((item) => {
    if (item.checksum) {
      const entityId = new EntityId();
      entityId.setSize(item.size);
      entityId.setChecksum(item.checksum);
      return entityId.toString();
    }
    return item.jobId.toString();
  }),
};

export const mutations = {
  addItem: (state, item) => {
    console.log('item==========>', item);
    if (state.items.filter((i) => i.id === item.id).length === 0) {
      state.items.push(item);
    }
  },
  removeItem: (state, id) => {
    state.items = state.items.filter((i) => i.id !== id);
  },
  resetItems: (state) => {
    state.items = [];
  },
};

export const actions = {
  addToCart: async ({ commit }, data) => {
    const request = data;
    if (data.checksum) {
      const entityId = new EntityId();
      entityId.setSize(data.size);
      entityId.setChecksum(data.checksum);
      request.id = entityId.toString();
      request.itemType = 'entity';
    } else {
      request.id = data.jobId.toString();
      request.itemType = 'job';
    }
    commit('addItem', request);
  },
  removeFromCart: async ({ commit }, request) => {
    console.warn('removing items')
    const id = request.id || request.checksum;
    commit('removeItem', id);
  },
  createManifest: async ({ rootState }, request) => {
    console.log('creating data manifest', request.toObject());
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        ingestClient.createManifest(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from createmanifest ', err);
            return reject(err);
          }
          console.info('manifest created', response.toObject());
          return resolve(response);
        });
      });
    } catch (error) {
      console.log('caught error in createmanifest', error);
      return Promise.reject(error);
    }
  },
  createReport: async ({ rootState }, request) => {
    console.log('creating report', request.toObject());
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        ingestClient.createReport(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from CreateReport ', err);
            return reject(err);
          }
          console.info('report created', response.toObject());
          return resolve(response);
        });
      });
    } catch (error) {
      console.log('caught error in createmanifest', error);
      return Promise.reject(error);
    }
  },
  resetCart: async ({ commit }) => {
    commit('resetItems');
  },
};

export default {
  namespaced: true,
  state: emptyState(),
  getters,
  mutations,
  actions,
};
